import { useCallback, useMemo } from "react";
import "./Navbar.css";
import { useAuth } from "../../context/AuthContext";
import { useMessages } from "../../context/MessageContext";
import { NavLink } from "react-router-dom";

function Navbar() {
    const { user, logout } = useAuth();
    const { addMessage } = useMessages();

    const handleLogout = useCallback(() => {
        logout();
        addMessage("success", "Je bent uitgelogd.");
        window.location.href = "/login";
    }, [logout, addMessage]);

    const canAccessAccounts = user?.role === "admin" || user?.role === "superadmin";
    const isSuperadmin = user?.role === "superadmin";
    const canAccessCeoHollandRijnland =
        isSuperadmin || (
            user?.role === "admin" &&
            user?.onderzoeken?.includes("ceo-holland-rijnland")
        );
    const homeTarget = user ? "/blog" : "/";

    const { displayName, displayEmail } = useMemo(() => {
        if (!user) {
            return { displayName: "Sandra van Oss", displayEmail: "s.vanoss@leiden.nl" };
        }

        const name =
            [user.first_name, user.last_name].filter(Boolean).join(" ") ||
            user.username ||
            "Gebruiker";

        return {
            displayName: name,
            displayEmail: user.email || "",
        };
    }, [user]);

    return (
        <nav className="navbar">
            <div className="container">
                <div className="nav-left">
                    <img src="/logo-paars.png" alt="Kurtosis" className="logo" />
                    <NavLink to={homeTarget} className={({ isActive }) => isActive ? "active" : undefined}>Home</NavLink>
                    <NavLink to="/dashboards" className={({ isActive }) => isActive ? "active" : undefined}>Dashboards</NavLink>
                    {canAccessCeoHollandRijnland && (
                        <NavLink to="/respons" className={({ isActive }) => isActive ? "active" : undefined}>Respons & Berichten</NavLink>
                    )}
                    {canAccessAccounts && (
                        <NavLink to="/accounts" className={({ isActive }) => isActive ? "active" : undefined}>Accounts</NavLink>
                    )}
                    <NavLink to="/blog" className={({ isActive }) => isActive ? "active" : undefined}>Blog</NavLink>
                    <a href="/almee" className="badge-link">
                        <span className="status-dot"></span> Almee
                        <span className="badge">10</span>
                    </a>
                </div>
                <div className="nav-right">
                    <div className="nav-icons">
                        <NavLink to="/blog"><img src="/glass.png" alt="Search" className="nav-icon" /></NavLink>
                        <NavLink to="/settings" className={({ isActive }) => isActive ? "active" : undefined}><img src="/settings.png" alt="Settings" className="nav-icon" /></NavLink>
                        <NavLink to="/blog"><img src="/bell.png" alt="Notifications" className="nav-icon" /></NavLink>
                    </div>
                    <div className="profile-hover">
                        <img src="/avatar.png" alt="Profile" className="avatar" />
                        <NavLink to="/profile" className="user-info-anchor">
                            <div className="user-info">
                                <div className="user-name">{displayName}</div>
                                {displayEmail && <div className="user-email">{displayEmail}</div>}
                            </div>
                        </NavLink>
                        <div className="profile-menu">
                            <NavLink to="/profile" className="profile-menu-link">Profiel</NavLink>
                            <button type="button" className="profile-menu-button" onClick={handleLogout}>Uitloggen</button>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    );
}

export default Navbar;
